<div class="form-sec-col contribute-panel panel" [formGroup]="form">

  <mat-toolbar color="accent" appearance="outline">
    <mat-toolbar-row>
      Contribute
      <span class="toolbar-spacer"></span>
      <button mat-icon-button (click)="closeSidePanel()" class="btn">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div class="panel-content">

    <h4>What did you observe?</h4>
    <mat-form-field color="accent" appearance="outline" class="clearable grow">
      <mat-select placeholder="Observation type" formControlName="observation_type_code" required>
        @for (obsType of currentObservationTypesDIs; track obsType) {
          <mat-option [value]="obsType.id">
            {{obsType.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <h4>When did you observe?</h4>
    <mat-form-field color="accent" appearance="outline" class="grow">
      <mat-label>Date and time *</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="date_observed" [max]="maxDate" required />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <h4>Where did you observe?</h4>
    <button class="grow" type="button" mat-stroked-button (click)="placePinToggle($event)">
      Place pin on map
    </button>

    <div class="form-sec-row left-align">
      <mat-form-field color="accent" appearance="outline">
        <input matInput type="number" step="0.0001" placeholder="Latitude" formControlName="x" autocomplete="off"
          required />
      </mat-form-field>

      <mat-form-field color="accent" appearance="outline">
        <input matInput type="number" step="0.0001" placeholder="Longitude" formControlName="y" autocomplete="off"
          required />
      </mat-form-field>
    </div>

    <h4>Photographs</h4>
    <button class="grow" type="button" mat-stroked-button color="primary" (click)="fileInput.click()">
      Select from computer
    </button>

    <div>
      <div class="uploadfilecontainer" (click)="fileInput.click()" appDragDrop (fileDropped)="uploadFile($event)">
        <input hidden type="file" accept="image/*" #fileInput (change)="uploadFile($event.target.files)" />
        <span class="add-photo"><i class="material-icons md-20">add_photo_alternate</i> Add photo </span>
      </div>

      @for (file of imagesControl.value; track file; let i = $index) {
        <div class="files-list">
          <p>{{ file.name }}</p>
          <button class="delete-file" (click)="deleteAttachment(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      }
    </div>

    <h4>Description</h4>
    <mat-form-field color="accent" appearance="outline" class="grow">
      <textarea matInput placeholder="Please provide more detail." formControlName="description" rows="4"></textarea>
    </mat-form-field>

    <h4>Keywords</h4>
    <mat-form-field color="accent" appearance="outline" class="clearable grow">
      <mat-select placeholder="Keywords" formControlName="keywords" multiple>
        @for (obsType of (keywordsDictionary?.itemsObs | async); track obsType) {
          <mat-option [value]="obsType.id">
            {{ obsType.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="space-checkbox">
      <mat-checkbox formControlName="i_agree" required>
        I agree to the BGS
        <a href="https://www.bgs.ac.uk/help/terms_of_use.html" target="_blank">Terms and Conditions</a> and
        <a href="https://www.bgs.ac.uk/help/privacy.html" target="_blank">Privacy Policy</a>
      </mat-checkbox>
    </div>

    <div class="button-row">
      <button type="button" mat-stroked-button color="primary" [disabled]="resetDisabled" (click)="reset()">
        Reset
      </button>
      <button type="submit" mat-stroked-button color="accent" appearance="outline" [disabled]="searchDisabled"
        (click)="submit()">
        Submit
      </button>
    </div>

  </div>
</div>